import { render, staticRenderFns } from "./treeCascader.vue?vue&type=template&id=268a0148&scoped=true&"
import script from "./treeCascader.vue?vue&type=script&lang=js&"
export * from "./treeCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268a0148",
  null
  
)

export default component.exports